export default function handleImageSrc(payload) {
  if (typeof payload === 'object') {
    return payload.src || payload.path;
  }

  return payload;
}
